import axios from "./axios";

const getBasePath = () => {
  return window.location.pathname.includes('/admin') ? '/admin' : '';
};

export const createEvent = (body) => {
  const basePath = getBasePath();
  return axios
    .post(`${basePath}/events`, body)
    .then(({ data }) => data);
};

export const updateEvent = (slug, body) => {
  const basePath = getBasePath();
  return axios
    .put(`${basePath}/events/${slug}`, body)
    .then(({ data }) => data);
};

export const deleteEvent = (slug) => {
  const basePath = getBasePath();
  return axios
    .delete(`${basePath}/events/${slug}`)
    .then(({ data }) => data);
};